import { Component } from '@angular/core';
import { AngularFireAuth } from '@angular/fire/auth';
import { ActivatedRoute, ChildActivationStart, NavigationEnd, Router, RoutesRecognized } from '@angular/router';
import { UserService, MetadataList } from './providers/user.service';

@Component({
	selector: 'app-root',
	templateUrl: './app.component.html',
	styleUrls: ['./app.component.scss']
})
export class AppComponent {

	title = 'LIMS';
	pageTitle = '';
	accessString = ''

	// _menuList: MenuItem[] = [
	// 	{
	// 		name: 'NCBI Download',
	// 		url: '/forms/ncbi-download',
	// 		icon: 'download'
	// 	},
	// 	{
	// 		name: 'Interaction',
	// 		url: '/forms/animal-interaction',
	// 		icon: 'science'
	// 	},
	// 	{
	// 		name: 'Inventory',
	// 		url: '/forms/animal-inventory',
	// 		icon: 'history',
			
	// 	},
	// 	{
	// 		name: 'Project Details',
	// 		url: '/forms/project-details',
	// 		icon: 'list'
	// 	},
	// 	{
	// 		name: 'User Form',
	// 		url: '/forms/user-form',
	// 		icon: 'people'
	// 	},
	// 	{
	// 		name: 'Animal List',
	// 		url: '/forms/animal-list',
	// 		icon: 'list_alt'
	// 	}
	// ]


	//-------------------------foldable side menu----------------------------------//
	_menuList: MenuItem[] = [
		// {
		// 	name: 'External',
		// 	url: '',
		// 	icon: 'extension',
		// 	children:[
		// 		{
		// 			name: 'NCBI Download',
		// 			url: '/forms/ncbi-download',
		// 			icon: 'download'
					
		// 		}
		// 	]
		// },
		{
			name: 'Admin',
			url: '',
			icon: 'extension',
			accessKey: 'Admin123',
			children:[
				{
					name: 'Schedule Template',
					url: '/forms/planning-metadata',
					icon: 'donut_small',
					accessKey: ''
					
				},
				{
					name: 'Internal User',
					url: '/forms/user-form',
					icon: 'people',
					accessKey: ''
				}
		
				,
				{
					name: 'Customer',
					url: '/forms/customer-form',
					icon: 'location_city',
					accessKey: ''
				},
				{
					name: 'Delete Log',
					url: '/forms/delete-log',
					icon: 'delete',
					accessKey: ''
				}
			]
		},
		{
			name: 'Animal',
			url: '',
			icon: 'pets',
			accessKey: '',
			children:[
				{
					name: 'Inventory',
					url: '/forms/animal-inventory',
					icon: 'history',
					accessKey: ''
					
				},
				{
					name: 'Interaction',
					url: '/forms/animal-interaction',
					icon: 'science',
					accessKey: ''
					
				},
				{
					name: 'Planning',
					url: '/forms/animal-planning',
					icon: 'equalizer',
					accessKey: ''
					
				},
				// {
				// 	name: 'Report',
				// 	url: '/forms/animal-report',
				// 	icon: 'report'
					
				// },
				{
					name: 'Task',
					url: '/forms/animal-task',
					icon: 'task',
					accessKey: ''
					
				}
				// ,
				// {
				// 	name: 'Animal List',
				// 	url: '/forms/animal-list',
				// 	icon: 'list_alt'
					
				// }
				
			]
		},
		{
			name: 'Project Details',
			url: '', // '/forms/project-details',
			icon: 'list',
			accessKey: '',
			children:[
				{
					name: 'Search',
					url: '/forms/project-details',
					icon: 'search',
					accessKey: ''
					
				},
				{
					name: 'Search New',
					url: '/forms/project-detailsNew',
					icon: 'youtube_searched_for',
					accessKey: ''
					
				},
				{
					name: 'Update',
					url: '/forms/project-update',
					icon: 'update',
					accessKey: ''
					
				},
				{
					name: 'Create',
					url: '/forms/project-create',
					icon: 'create',
					accessKey: ''
					
				},
			]

		}
		,
		// {
		// 	name: 'Experiment',
		// 	url: '/forms/western-blot',
		// 	icon: 'assessment',
		
		// },
		{
			name: 'Lab Notes',
			url: '',
			icon: 'assessment',
			accessKey: 'Admin1234',
			children:[
				{
					name: 'Protein Chemistry',
					url: '',
					icon: 'assessment',
					accessKey: '',
					children:[
						// {
						// 	name: 'Elisa',
						// 	url: '/forms/elisa',
						// 	icon: 'assessment'
							
						// },
						{
							name: 'Western Blot',
							url: '/forms/western-blot',
							icon: 'assessment',
							accessKey: ''
							
						},
						{
							name: 'Western Blot Gel Setup',
							url: '/forms/wbgel-setup',
							icon: 'assessment',
							accessKey: ''
							
						}
					]
				},
				// {
				// 	name: 'Cell Biology',
				// 	url: '/forms/cell-biology',
				// 	icon: 'assessment'
					
				// }
			]
		}
		// ,
		// {
		// 	name: 'Experiment Gel',
		// 	url: '/forms/experiment-gel',
		// 	icon: 'pin_drop',
		
		// }
		,{
			name: 'Contact Us',
			url: '',
			icon: 'contact_support',
			accessKey: '',
			children:[
				{
					name: 'Help',
					url: '/forms/help',
					icon: 'help_outline',
					accessKey: ''
					
				},
				{
					name: 'Help Log',
					url: '/forms/help-log',
					icon: 'list_alt',
					accessKey: ''
					
				},
			]
		}
		
		
	]


	
	menuList: MenuItem[] = []

	constructor(private router: Router, public auth: AngularFireAuth,
		private userService: UserService, private activatedRoute: ActivatedRoute) {

		auth.authState.subscribe(async (state: any) => {
			await this.userService.validateUser(state);
			this.menuList = this.userService.isAuthenticated() ? this._menuList : [];
			this.accessString=this.userService.getAccess();
			var animalActivityData=await this.userService.getAnimalActivityDB();
			const sortedKeyTexts: string[] = animalActivityData
  					.sort((a, b) => a.sort_order - b.sort_order)
  					.map(item => item.key_value);
			localStorage.setItem("animalInteractionDB", JSON.stringify(sortedKeyTexts));
		});

		this.router.events.subscribe(res => {
			
			if (res instanceof NavigationEnd) {
//debugger;
				this._menuList.forEach(a => {
					

					if(a.children){

						a.children.forEach(ele =>{

							if(ele.children){
								ele.children.forEach(element => {
									if(element.url ===res.url){
										this.pageTitle = a.name + ' > '+ele.name+ ' > '+element.name;
									}
								});
							}
							


							else if(ele.url ===res.url){
								this.pageTitle = a.name + ' > '+ele.name;
							}
						})


					}
					else{
						if(a.url ===res.url){
							this.pageTitle = a.name;
						}
						
					}

					// this.pageTitle = this._menuList.find(f => f.url == res.url)?.name || 'Home';


				});

				// if(res.url === '/forms/animal-interaction'){
				// 	this.pageTitle = 'Interaction' 
				// }

			
				
			}

			

			
		})
		
	}

	getUser() {
		return this.userService.user;
	}

	navigate(url: string) {
		////debugger;
	//	this.router.navigate([url]);
		this.router.navigateByUrl('/', {skipLocationChange: true}).then(()=>
        this.router.navigate([url]));
	}

	navigateWithParam(url: string,value:string) {
		//debugger;
	//	this.router.navigate([]).then(result => {  window.open(url+'?key='+value, '_blank'); });
	//	this.router.navigate([url]);
		this.router.navigateByUrl('/', {skipLocationChange: true}).then(()=>
        this.router.navigate([url],{ queryParams: { key: value } } ));
	}

	navigateWithParamTab(url: string,value:string) {
		//debugger;
		this.router.navigate([]).then(result => {  window.open(url+'?key='+value, '_blank'); });
	
	}
}

interface MenuItem {
	name: string;
	url: string;
	icon: string;
	accessKey : string ;
	children?: MenuItem[] 
}
